import React, { useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { t } from "i18next";
import { useAppContext } from "../../components/context/appContext"


import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, PrinterTypes } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';
import { Box, Divider, IconButton } from "@mui/material";
import { MuiButton } from "../../components/mui";


import cameraApi from "../../api/cameraApi";
import cameraModelApi from "../../api/cameraModelApi";
import simSupplierApi from "../../api/simSupplierApi";
import { printColorboxRFID } from "../../utils/prodlocalhelper";

function ColorboxRFIDReprint(){

  const appContext = useAppContext();

  const [lastScanedValue, setLastScannedValue] = useState();
  const [scannerValue, setScannerValue] = useState();
  const [autoPrint, setAutoPrint] = useState(true);
  const [simSuppliers, setSimSuppliers] = useState([]);
  const [currentCamData, setCurrentCamData] = useState();
  const [camEncodingText, setCamEncodingText]=useState();

  useEffect(()=>{
    simSupplierApi.getSimSuppliers().then((res)=>{
      setSimSuppliers(res.data);
    });
  },[]);

  useEffect(()=>{
    if(autoPrint && currentCamData?.serialNo)
      printColorboxLabel();
  },[currentCamData])

  function scannerOnKeyDown(e){
    if (e.key === 'Enter') {
      handleScan(e.target.value);
    }
  }

  async function handleScan(value) {
    if(value){
      

      const serialNumber = value.split(',')[0];
      console.log(serialNumber);
      const camera = (await cameraApi.getCameraBySerialnumber(serialNumber)).data;
      let sim1 = "";
      let sim2 = "";
      if(camera.sims){
        if(camera.sims.lenght >= 1)
          sim1 = getSupplierLetter(camera.sims[0])
        if(camera.sims.lenght >= 2)
          sim2 = getSupplierLetter(camera.sims[1])
      }

      //TODO Validate if camera already has an RFID tag.
      console.log(camera)
      if(camera.rfidEpc){
        return appContext.showMessage(t('warning'), t("colorboxRfidReprint.migration_already_done"));
      }

      if(scannerValue === lastScanedValue){
        return appContext.showMessage(t('warning'), t("colorboxRfidReprint.double_scan"));
      }

      setLastScannedValue(scannerValue);
      setCurrentCamData({
        camId: camera.id,
        datamatrix: scannerValue,
        serialNo: camera.serialNumber,
        sim1:sim1,
        sim2:sim2
      });
      setCamEncodingText(`Datamatrix:${scannerValue}\nSerialNumber: ${camera.serialNumber}\nSim 1:${sim1}\nSim2:${sim2}`);
    }
  }

  function getSupplierLetter(sim) {
    const match = simSuppliers.find(s => sim.startsWith(s.prefix));
    return match ? match.letter : null;
  };

  function printColorboxLabel() {
    if(appContext.printerStatusRFID !== 'ready'){
      return appContext.showMessage(t('warning'), t("dashboard_main.local_printer_not_ready"));
    }
    printColorboxRFID({},(err, res)=>{
      saveRfidOnCamera(res.data);
    })
    //TODO Make a backend call that does it all!!
    //TODO Send EPC to ekanban via prodapi
    //TODO Migration to new model
    //TODO Send to Netsuite
    //Basically call camera/colorbox migration endpoint instead of saveRy
  }
  async function saveRfidOnCamera(rfidEpc) {
    await cameraApi.putCamera(currentCamData.camId, {rfidEpc:rfidEpc});
  }

  return (<>
    <StandardPage title={t("colorboxRfidReprint.title")}
            description={t("colorboxRfidReprint.title_desc")}
            showPrinterStatus={true}
            printerType = {PrinterTypes.RFID}>
      <StandardPageTopContent>
        <MuiRow>
          <MuiCol size={{ xs:12}}>
            <ScannerInput onChange={setScannerValue}
                value={scannerValue}
                onKeyDown={scannerOnKeyDown}
                label={t("colorboxRfidReprint.scanColorbox")}
            />
          </MuiCol>
        </MuiRow>
      </StandardPageTopContent>
      <StandardPageMainContent>
        <MuiRow spacing={2}>
          <MuiCol size={{ xs:6 }}>
            <Box
              sx={{
                backgroundColor: 'grey.100',
                border: '1px solid grey',
                borderRadius: '8px',
                padding: 2,
                marginTop:1,
                marginBottom:2,
                width: '100%',
              }}>
                <MuiTextArea disabled
                  value={camEncodingText}/>
             
              </Box>
          </MuiCol>
          <MuiCol size={{ xs:6 }}>
            <MuiButton large disabled={autoPrint || !(currentCamData?.serialNo)} onClick={()=>{console.log("hello")}}>{t("print")}</MuiButton>
            <MuiCheckbox label={t("colorboxRfidReprint.autoPrint")}
              value={autoPrint}
              onChange={setAutoPrint} />
          </MuiCol>
        </MuiRow>
      </StandardPageMainContent>
    </StandardPage>
  </>)
}

ColorboxRFIDReprint.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  connect(
    mapStateToProps,
  )
)(ColorboxRFIDReprint);